module.exports = __webpack_public_path__ + "img/milky_app.d3693259.png";